import {lazy} from '@aboutyou/lazy-imports';

export const BuyNowPayLaterStatus = lazy(() =>
  import('./BuyNowPayLaterStatus.eager').then(mod => ({
    default: mod.BuyNowPayLaterStatus,
  })),
);
